import type { ComponentType } from 'react'
import type { SceneId } from '#app/utils/site/content'
import { ApprovePhoneScene } from './ApprovePhoneScene'
import { BankStatementScene } from './BankStatementScene'
import { DeviceMorphScene } from './DeviceMorphScene'
import { FakeStatementLensScene } from './FakeStatementLensScene'
import { LeaseLmrScene } from './LeaseLmrScene'
import { RenterProfileScene } from './RenterProfileScene'
import type { SceneProps } from './types'

/** Scene id (from content.ts) to the component that draws it. */
export const SCENES: Record<SceneId, ComponentType<SceneProps>> = {
	'renter-profile': RenterProfileScene,
	'bank-statement': BankStatementScene,
	'device-morph': DeviceMorphScene,
	'fake-statement-lens': FakeStatementLensScene,
	'approve-phone': ApprovePhoneScene,
	'lease-lmr': LeaseLmrScene,
}
